export default (function () {
  const navbarCollapse = document.querySelectorAll(".navbar-collapse");

  function getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }

  function overflowHide() {
    const scrollbarWidth = getScrollbarWidth();

    document.documentElement.style.overflow = "hidden";
    document.body.style.paddingRight = scrollbarWidth + "px";
  }

  function overflowShow() {
    document.documentElement.style.overflow = "";
    document.body.style.paddingRight = "";
  }

  [].forEach.call(navbarCollapse, function (collapse) {
    $(collapse).on({
      "show.bs.collapse": function () {
        overflowHide();
      },
      "hidden.bs.collapse": function () {
        overflowShow();
      },
    });
  });
});
